module.exports = __webpack_public_path__ + "static/img/2_6_1.3aceed91.jpg";